var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26828 2.40313L2.79659 8.87483C2.27023 9.40119 1.92942 10.0845 1.82563 10.8216L1.50574 13.0934C1.44189 13.5468 1.83176 13.9343 2.28477 13.8676L4.60201 13.5267C5.33128 13.4194 6.00657 13.0799 6.52779 12.5587L12.9758 6.11068M9.26828 2.40313L10.2164 1.45501C11.02 0.65143 12.3228 0.651433 13.1264 1.45501L13.924 2.25258C14.7275 3.05615 14.7275 4.35899 13.924 5.16256L12.9758 6.11068M9.26828 2.40313L12.9758 6.11068",
    stroke: "#FF0990",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.71b90d4f.svg";
export { ForwardRef as ReactComponent };